import React from 'react';
import PropTypes from 'prop-types';
import { graphql, gql, compose } from 'react-apollo';
import { FormattedMessage, injectIntl } from 'react-intl';
// Style
import {
  Grid,
  Row,
  Col,
  Panel
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './SubscriptionContainer.css';
import cx from 'classnames';
import bt from '../../components/commonStyle.css';


// Graphql
import getAllSubscriptionQuery from './getAllSubscriptionQuery.graphql';

// Component
import SideMenu from '../../components/ManageSubscription/SideMenu/SideMenu';
import Subscription from '../../components/Subscription';
import NoItem from '../../components/Subscription/NoItem';
import Loader from '../../components/Loader';
import CustomPagination from '../../components/CustomPagination';

// Locale
import messages from '../../locale/messages';

class SubscriptionContainer extends React.Component {
  static propTypes = {
    formatMessage: PropTypes.func,
    userType: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
      getAllReservation: PropTypes.shape({
        count: PropTypes.number,
        reservationData: PropTypes.array
      }),
      refetch: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1
    };
    this.paginationData = this.paginationData.bind(this);
  }

  paginationData(currentPage) {
    const { data: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage });
    refetch(variables);
  }

  render() {
    const { data: { loading, getAllReservation }, userType, type } = this.props;
    const { currentPage } = this.state;
    const { formatMessage } = this.props.intl;
    let title;
    if (userType === 'host') {
      //title = <FormattedMessage {...messages.yourReservations} />
      title = (type == 'active') ? <FormattedMessage {...messages.activeSubscriptions} /> : <FormattedMessage {...messages.cancelledSubscriptions} />;
    } else {
      //title = <FormattedMessage {...messages.yourTrips} />
      title = (type == 'active') ? <FormattedMessage {...messages.activeSubscriptions} /> : <FormattedMessage {...messages.cancelledSubscriptions} />;
    }

    return (
      <div>
        <Grid fluid className={s.container}>
          <Row className={s.landingContainer}>
            <SideMenu />
            <Col xs={12} sm={8} md={8} lg={8}>
              <div className={cx('commonListingBg', 'tripContainer')}>
                <Panel className={s.panelHeader}>
                <div>
                    <h3 className={bt.listingTitleText}>{title}</h3>
                  </div>
                  {
                    loading && <Loader type={"text"} />
                  }
                  {
                    !loading && getAllReservation !== undefined && getAllReservation !== null
                    && getAllReservation.reservationData.length > 0 && <Subscription
                      data={getAllReservation.reservationData}
                      userType={userType}
                    />
                  }
                  {
                    getAllReservation !== undefined && getAllReservation !== null
                    && getAllReservation.reservationData.length > 0 && <CustomPagination
                      total={getAllReservation.count}
                      currentPage={getAllReservation.currentPage}
                      defaultCurrent={1}
                      defaultPageSize={5}
                      change={this.paginationData}
                      paginationLabel={formatMessage(messages.panelSubscription)}
                    />
                  }
                  {
                    !loading && getAllReservation !== undefined && getAllReservation !== null
                    && getAllReservation.reservationData.length === 0 && <NoItem
                      userType={userType}
                      type={type}
                    />
                  }
                </Panel>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default compose(
  injectIntl,
  withStyles(s, bt),
  graphql(getAllSubscriptionQuery,
    {
      options: (props) => ({
        variables: {
          userType: props.userType,
          subscriptionStatus: props.type == 'active',
          currentPage: 1
        },
        fetchPolicy: 'network-only',
      })
    }
  ),
)(SubscriptionContainer);


// WEBPACK FOOTER //
// src/routes/subscription/SubscriptionContainer.js